<template>

  <div>


      <!-- Utility Account Not Found ............................ -->
<!-- @TODO
    <el-form v-if="site" name="utilityAddressForm" :model="site">
      <div v-if="changeAddress && canAccess('finance')">
        <el-alert
        title="Billing Address Empty"
        type="warning"
        description="Please enter utility billing address and account no."
        show-icon>
      </el-alert>
      <br />

      <el-col :span="24">
          <select-utility label="Provider" v-model="site.landonwer.util_id" />
      </el-col>


      <el-form-item label="Account No.">
        <el-input v-model="site.tenancy.utilAccount" placeholder="Account No."></el-input>
      </el-form-item>

      <el-form-item label="Address" prop="address">
        <el-input type="textarea" v-model="site.tenancy.utilAddress" placeholder="Billing Address"></el-input>
      </el-form-item>

      <el-row>
        <el-col :span="24" align="right">
          <el-button @click="saveAddress" type="info">Save Address</el-button>
        </el-col>
      </el-row>
      <hr>
    </div>
  </el-form>
-->



  <el-form v-if="bill" ref='utilityBillForm' :model="bill" :rules="rules" label-width='124px'>

    <!-- Actual Bill Details ............................ -->

    <h3>{{utilLabel}} Bill</h3>

    <el-row>
      <el-col :sm="24" :md="16" :lg="16" align="left">
        <text-input label="Invoice No" v-model="bill.invoiceNo" prop="invoiceNo" required />
      </el-col>

      <el-col :sm="24" :md="4" :lg="4">
        <el-form-item label=" ">
          <el-button type="warning" size="small" icon="fa fa-edit" v-show="!adjust" @click="adjust=true">Adjust</el-button>
        </el-form-item>
      </el-col>

      <el-col :span="24" align="left">
        <date-input label="From / To" type="daterange" v-model="period" />
      </el-col>
    </el-row>

  </el-row>

  <el-row style="padding-top: 0.5rem; border-radius: 14px;" :gutter="gutter" class="bg-lighter">

    <el-col :md="24" :lg="8">
      <float-input :label="amountLabel" v-model="bill.amount" prop="amount" required />
    </el-col>

    <el-col :md="24" :lg="8">
        <date-input label="Bill Date" v-model="bill.date" prop="date" />
    </el-col>

    <el-col :md="24" :lg="8">
        <check-box label="Include Tax" v-model="includeTax" />
    </el-col>

  </el-row>
</el-form>


<el-form name="billingDetailsForm2" :model="bill" label-position="top">

  <el-row :gutter="gutter">

    <el-col  v-if="includeTax" :md="12" :lg="8">

      <float-input v-if="adjust" :label="taxLabel  + ' ' + this.formatNumber(bill.taxRate) + '%'"
        prop="tax" v-model="bill.tax"  />

      <el-form-item v-else :label="taxLabel  + ' ' + this.formatNumber(bill.taxRate) + '%'">
        <b>{{bill.tax}}</b>
      </el-form-item>


        <float-input v-show="adjust" label="Tax Rate"
          prop="tax" v-model="bill.taxRate" suffix="%" :disabled="!adjust" />

    </el-col>

    <el-col v-if="includeTax" :md="12" :lg="8">

      <float-input
          label="Non-Tax Charges"
          prop="untaxedCharges"
          v-model="bill.untaxedCharges"  />

    </el-col>

    <el-col :md="12" :lg="8">

      <float-input
          :label="overdueLabel"
          prop="overdue"
          v-model="bill.overdue"  />

    </el-col>

  </el-row>


  <el-row :gutter="gutter">
    <el-col :md="12" :lg="8">

      <float-input
          label="Penalties"
          prop="penalty"
          v-model="bill.penalty"  />

    </el-col>

    <el-col :md="12" :lg="8">

      <float-input
          label="Rounding"
          prop="rounding"
          v-model="bill.rounding"  />

    </el-col>

    <el-col :md="12" :lg="8">

      <float-input
          :label="extraChargesLabel"
          prop="extraCharges"
          v-model="bill.extraCharges"  />

    </el-col>

  </el-row>

  <el-row :gutter="gutter">

    <el-col v-if="includeTax" :span="23" align="right">
      Sub-Total: <b>{{formatNumber(this.subtotals)}}</b>
    </el-col>
    <el-col v-if="includeTax" :span="23" align="right">
      Tax: <b>{{formatNumber(this.taxes)}}</b>
    </el-col>
    <el-col :span="23" align="right">
      TOTAL: <b>{{formatNumber(this.totals)}}</b>
    </el-col>
  </el-row>
</el-form>


<!-- Sharing Calculation Table ............................ -->
<el-row v-if="siteData && bill.total > 0">
  <utility-sharing-table ref="sharingTable" title="Sharing Calculation" :tax="includeTax" :row-data="bill" :site-id="siteData.id" />
</el-row>


<!-- Bill Upload ............................
<el-row>
<h4>Upload {{utilLabel}} Bill</h4>
</el-row>

<el-row>
<el-col :span="24">
<files-panel type="utility" :id="siteData.id" />
</el-col>
</el-row>
-->

</div>

</template>

<script>

import PostMixins from '@/mixins/PostMixins'
import NumberMixins from '@/mixins/NumberMixins'
import DateMixins from '@/mixins/DateMixins'

import FilesPanel from '@/components/atoms/files/FilesPanel'

import UtilitySharingTable from '@/components/utility/UtilitySharingTable'

import {settings} from '@/components/Data'

export default {
  mixins: [DateMixins, NumberMixins, PostMixins],

  components: {
    FilesPanel,
    UtilitySharingTable
  },

  props: {
    siteData: {
      type: Object,
      required: true
    },
    showText: {
      type: Boolean,
      default: true
    },
    tableRef: {
      type: String,
      default: 'utiltable'
    },
    buttonSize: {
      type: String,
      default: 'default'
    }
  },

  computed: {
    subtotals: function () {
      if (this.includeTax) {
        return Number(Number(this.bill.total) - Number(this.bill.tax)).toFixed(2)
      } else {
        return Number(this.bill.total).toFixed(2)
      }
    },

    totals: function () {
      this.bill.total = Number(this.bill.amount) + (this.includeTax ? Number(this.bill.tax) : 0) +
       Number(this.bill.untaxedCharges) + Number(this.bill.overdue) +
      Number(this.bill.penalty) +
      (this.extraCalcTotal ? Number(this.bill.extraCharges) : 0.00) +
      Number(this.bill.rounding)

      return Number(this.bill.total).toFixed(2)
    },

    taxes: function () {
      if (this.includeTax) {
        this.bill.tax = this.taxDue(this.bill.amount)
        return this.bill.tax
      } else {
        this.bill.tax = 0
        return this.bill.tax
      }
    }
  },

  watch: {
    bill: function (value) {
      this.$forceUpdate()
    }
  },

  methods: {
    update () {
      /*
      this.$message({
        center: true,
        dangerouslyUseHTMLString: true,
        message: 'Please <b>refresh</b> <i class="fa fa-sync"></i> the sharing table.',
        type: 'info'
      })
      */
    },

    saveAddress () {
      this.changeAddress = false
    },

    submitUpload () {
      this.$refs.upload.submit()
    },

    resetData () {
      this.adjust = false
      this.bill = this.getTableStruct('utility')
    },

    onSave () {
      this.bill.site_id = this.siteData.id
      this.bill.date = this.formatDateSql(this.bill.date)
      this.bill.taxName = this.taxLabel

      if (this.period && this.period.length === 2) {
        this.bill.periodFrom = this.formatDateSql(this.period[0])
        this.bill.periodTo = this.formatDateSql(this.period[1])
      }

      this.saveForm(this, '/utility', this.bill.id, this.bill, 'Utility', this.success)
    },

    onClose () {
      this.resetData()
    },

    success (response) {
//      this.siteData.utilities.push(this.bill)
      this.$events.emit(this.tableRef + '-' + 'refresh-table')
      this.resetData()
    }

  },

  data () {
    return {
      gutter: 8,
      showDelete: true,
      adjust: false,
      includeTax: this.showTax(),

      period: [],

      currency: settings.currency,

      utilLabel: this.getUtilLabel(this.siteData),
      taxLabel: settings.taxName,

      overdueLabel: settings.utilOverdueLabel,
      amountLabel: settings.utilAmountLabel,
      extraChargesLabel: settings.utilExtraInputLabel,

      negUnTaxed: settings.utilNegUntaxedTotal,

      extraCalcTotal: settings.utilExtraInputTotal,

      bill: this.getTableStruct('utility'),

      site: this.siteData,

      changeAddress: (!this.siteData.tenancy.utilAddress || this.siteData.tenancy.utilAddress === '') || (!this.siteData.tenancy.utilAccount || this.siteData.tenancy.utilAccount === ''),
      rules: {
        invoiceNo: [
          { required: true, message: 'Please enter invoice no.', trigger: 'blur' }
        ],
        amount: [
          { required: true, message: 'Please enter current amount due', trigger: 'change' }
        ],
        date: [
          { required: true, message: 'Please enter ' + this.getUtilLabel(this.siteData) + ' bill date', trigger: 'blur' }
        ]
      }
    }
  },  // data

  created () {

    this.bill.taxName = settings.taxName
    this.bill.taxRate = settings.taxRate

    if (!this.period && this.bill.periodFrom && this.bill.periodTo) {
      this.period.push(this.bill.periodFrom)
      this.period.push(this.bill.periodTo)
    }

    this.bill.site_id = this.site.id
    this.bill.utilityDeposit = settings.utilStandardDeposit
  }
}

</script>
